// usePackageList - laedt die Paketliste einer Quelle mit Fehlerbehandlung.
// SAP CPI IntegrationPackages: KEIN $select, KEIN $inlinecount (beide werfen HTTP 501).
// Der Endpoint /api/:iid/transport/packages liefert bereits ein d.results-Objekt
// oder ein direktes Array.

import { useEffect, useState, useCallback } from "react";
import { api } from "../../../utils/helpers";
import { useLang } from "../i18n";

export function usePackageList(sourceInstanceId) {
  const { t } = useLang();
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reloadNonce, setReloadNonce] = useState(0);

  const reload = useCallback(() => setReloadNonce((n) => n + 1), []);

  useEffect(() => {
    if (!sourceInstanceId) {
      setPackages([]);
      setLoading(false);
      return;
    }
    let mounted = true;
    const controller = new AbortController();
    setLoading(true);
    setError(null);
    api(`/api/${sourceInstanceId}/transport/packages`, { timeout: 45000, retry: false, signal: controller.signal })
      .then((res) => {
        if (!mounted) return;
        const raw = Array.isArray(res?.d?.results) ? res.d.results : Array.isArray(res) ? res : [];
        if (raw.some(p => typeof p?.Id !== "string" || !p.Id.trim())) throw new Error(t("s2.missingPackageId"));
        const list = raw.map((p) => ({
          id: p.Id,
          name: p.Name || p.Id,
          shortText: p.ShortText || "",
          version: p.Version || "",
          mod: p.ModifiedDate || p.ModifiedAt || null,
        })).filter((p) => p.id);
        setPackages(list);
        setLoading(false);
      })
      .catch((e) => {
        if (!mounted) return;
        setPackages([]);
        setError(e?.message || "Pakete konnten nicht geladen werden");
        setLoading(false);
      });
    return () => { mounted = false; controller.abort(); };
  }, [sourceInstanceId, reloadNonce, t]);

  return { packages, loading, error, reload };
}
